/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { SelectField, ContentModuleModal } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';

import Form from '../Form';

import { TYPES, INITIAL_VALUES } from './constants';
import Item from './Item';

const StatsPanel = ({ visible, onSubmit, hide, previewImg, onDelete, type = INITIAL_VALUES.type, errors }) => {
  const [form] = Form.useForm();
  const initialValues = { type };

  const handleFinish = React.useCallback(
    (values) => {
      onSubmit({}, values.type);
      hide();
      form.resetFields();
    },
    [form, hide, onSubmit],
  );
  const handleCancel = () => {
    form.resetFields();
    hide();
  };
  return (
    <ContentModuleModal
      visible={visible}
      title="Stats"
      subtitle="Choose a Stats module to feature on a page"
      okText={onDelete ? 'SAVE CHANGES' : 'ADD STATS'}
      onCancel={handleCancel}
      onSubmit={form.submit}
      onDelete={onDelete}
      heroImageSrc={previewImg}
      errors={errors}
    >
      <Form
        form={form}
        hideRequiredMark
        layout="vertical"
        wrapperCol={{ span: 12 }}
        initialValues={initialValues}
        onFinish={handleFinish}
      >
        <SelectField name="type" label="Choose the stat feature" options={TYPES} style={NO_MARGIN_BOTTOM} />
      </Form>
    </ContentModuleModal>
  );
};

StatsPanel.Item = Item;

export default StatsPanel;
